import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@api-client';
import { UserAuthStore } from '../stores/user.store';

export const NoLoginGuard = async () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const userAuthStore = inject(UserAuthStore);

  userService.userControllerMe().subscribe({
    next: (user) => {
      if (user) {
        userAuthStore.setUser(user);
        router.navigate(['/']);
      } else {
        return user;
      }
    },
    error: () => {},
  });
};
